import type { Business } from '../api/client'
import { depositExample } from '../screens/settings/depositForm'

// The no-show prompt is offered once per appointment (spec 1.7): marking the
// same no-show again, after an Undo, says nothing more. Remembered on this
// device; a blocked store just remembers for the session.
const KEY = 'harmovi.noShowPrompted'
const KEEP = 200
const seen = new Set<string>()

function stored(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]')
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function noShowPrompted(appointmentId: string): boolean {
  return seen.has(appointmentId) || stored().includes(appointmentId)
}

export function rememberNoShowPrompt(appointmentId: string): void {
  seen.add(appointmentId)
  try {
    localStorage.setItem(KEY, JSON.stringify([...stored().filter((id) => id !== appointmentId), appointmentId].slice(-KEEP)))
  } catch {
    // The in-memory set covers this session.
  }
}

// missedDeposit is what her deposit policy would have taken on a booking at
// this price, as the booking page works it out (depositForm); 0 with no policy.
export function missedDeposit(business: Pick<Business, 'deposit_policy' | 'deposit_amount_pence' | 'deposit_percentage'> | null, pricePence: number): number {
  if (!business) return 0
  return depositExample(
    { policy: business.deposit_policy, amountPence: business.deposit_amount_pence, percentage: business.deposit_percentage },
    pricePence,
  )
}
